import React from 'react';
import {getCookie} from "../utils/cookies";
import {accessTokenKey} from "../core/AuthInterceptor";
import {Navigate, Outlet} from "react-router-dom";
import {termsService} from "../services/terms.service";

const PublicOnlyGuard = () => {
    const token = getCookie(accessTokenKey);

    if (token) {
        const requiredConsent = termsService.getPendingEulaVersion() !== null;
        const redirectPath = requiredConsent ? "/eula" : "/dashboard";

        return <Navigate to={redirectPath} replace />;
    }
    return <Outlet />;
};

export default PublicOnlyGuard;